export default __webpack_public_path__ + "static/media/activity.475b5639.svg";